import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


//开启debug模式
Vue.config.debug = true;
Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'index',
      redirect:'/index',
    },
    {
      path:'/index',
      name:'index',
      component: () => import('@/view/index/home.vue'),
      meta:{show:true},
    },
    {
      path:'/category',
      name:'category',
      component: () => import('@/view/index/category.vue'),
      meta:{show:true},
    },
    {
      path:'/details',
      name:'details',
      component: () => import('@/view/index/details.vue'),
      meta:{show:true},
    },
    {
      path:'/cart',
      name:'cart',
      component: () => import('@/view/index/cart.vue'),
      meta:{show:true},
    },
    {
      path:'/checkout',
      name:'checkout',
      component: () => import('@/view/index/checkout.vue'),
      meta:{show:false},
    },
    {
      path:'/login',
      name:'login',
      component: () => import('@/view/index/login.vue'),
      meta:{show:true},
    },
    {
      path:'/register',
      name:'register',
      component: () => import('@/view/index/register.vue'),
      meta:{show:true},
    },
    {
      path:'/about-us',
      name:'about-us',
      component: () => import('@/view/pages/about-us.vue'),
      meta:{show:true},
    },
    {
      path:'/privacy-policy',
      name:'privacy-policy',
      component: () => import('@/view/pages/privacy-policy.vue'),
      meta:{show:true},
    },
    {
      path:'/return-policy',
      name:'return-policy',
      component: () => import('@/view/pages/return-policy.vue'),
      meta:{show:true},
    },
    {
      path:'/contact-us',
      name:'contact-us',
      component: () => import('@/view/pages/contact-us.vue'),
      meta:{show:true},
    },
    {
      path:'/shipping-policy',
      name:'shipping-policy',
      component: () => import('@/view/pages/shipping-policy.vue'),
      meta:{show:true},
    },
     {
      path:'/terms-conditions',
      name:'terms-conditions',
      component: () => import('@/view/pages/terms-conditions.vue'),
      meta:{show:true},
    },
    {
      path:'/account',
      name:'account',
      component: () => import('@/view/index/account.vue'),
      meta:{show:true},
    },
  ]
})
// router.beforeEach((to, from, next) => {
//   NProgress.start() 
//   next()
// })

router.afterEach(() => {
  // NProgress.done()
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})
const routerRePush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}
export default router





// WEBPACK FOOTER //
// ./src/router/index.js